import { GridCellField } from './grid-cell-field';
import { BaseSelectionAppField, SelectionAppField } from './selection-app-field';

export class SelectionGridCellField<T> extends GridCellField<BaseSelectionAppField<T>> {

  public getSelectListOptions() {
    return this.containedField.getSelectListOptions();
  }
}
